module.exports = __webpack_public_path__ + "img/csu.97b99a3f.jpg";